import { generateId } from "../../Lib";
const tips:string[]=[
    "Test 1",
    "Test 2",
    "Test 3",
    "Test 4",
    "Test 5",
    "Test 6",
    "There are tons of easter eggs in CMD; Try to find them all",
    "Did you know Boston is also called Beantown?",
    "I actually have a youtube! Please subscribe, I want to buy new cymbals for my drums but I have a bank balance of $-2.59",
    "Are you reading these?",
    "Ancient Greece used to elect public officials with beans! Another reason to love them",
    "Pythogoras hated beans. Stupid, robe wearing triangle guy; he doesn't have the right to an opinion",
    "Beans on toast are good, I don't care what you say",
    "British people are very scary",
    "run 'secret' in DOS; I dare you",
    "You know this project is open source? yeah, you can fuck it up in any way you want",
    "I spent 4 hours on this update please follow my socials",
    "Half the sh*t here is like an bean-themed aldi version of actual apps",
    "Tell your friends about Beansite! (I need money)",
    "Adsense rejected me :(",
    "pringles",
    "Lorem ipsum dolor sit amet",
    "Beans",
    "Hello, World!",
    "scrotum :P",
    "Sub to my yt pls",
    "balls",
    "Sorry about loading speeds, this project is HUGE!!",
    "beans beans beans. jessie ate some beans. he was happy, happy, happy that he ate some beans",
    "kurt cobian once wrote a song about beans (yes, he was sober)",
    "Hi",
    "Hola",
    "Fuck Google Adsense im switching to Adinplay",
    "Maybe ill get ads some day. if i do, i promise i wont spam. im not that greedy",
    "i think you should be in class, buddy",
    // "skibidi",
    // "skibidi toilet",
    // "sigma alpha male",
    // "skibidi toilet sigma alpha male livvy dunne and baby gronk fanum tax rizz ohio",
    "im slowly losing all braincells",
    "sometimes you need to close a door to open a window",
    "my brother said im on the spectrum",
    "dont call me selfish, i aint sharin",
    "remember, if yall wants game scroll to the bottom of BeanPowered I do requests yk",
    "js ask me for games and ill add em.",
    "WHAT THE FUCK IS A KILOMETER",
    "Some profound text goes here",
    "Pro tip: don't add cement to your bread. it's softer if you use yeast. thank me later",
    "478868574082066804",
    "Hrmm",
    "As seen on TV!",
    "May contain nuts",
    "Uses Vite/React/Redux/Sass (No, I don't touch grass)",
    "Correction: we use Vite/React/Jotai/Motion/Sass/BaseUI",
    "No, I don't touch grass",
    "1337",
    "Open-Source!",
    "9% bug free!",
    ".9% bug free!",
    "8% bug free!",
    ".8% bug free!",
    "help",
    "i haven't slept in 2 months",
    "My chemicial coochie juice",
    "chemicial coochie juice",
    "moster",
    "e",
    "Nothing to see here!",
    "im so fucking done with this",
    "Finally got rid of the god-forsaken codebase of beansite 95 and I couldn't be happier.",
    "im freeeee~",
    "sleep deprivations getting to my ass",
    "i cant believe it took so long to get here",
    "im so fucking proud. this project. its complete. ive fixed the bugs. ive overcome the problems. feels like part of me is finally complete",
    "thanks for playing yall",
    "I WANT ADS! FUCK ADSENSE I WANT MY FUCKING ADS",
    "yk the beansite xp sdk is rly easy to use. yall can literally make ur own beansites.",
    "just bought ANOTHER monitor (i still dont enough enough)",
    "the best things in life are free. Beansite is free, therfore, beansite is the best",
    "beansite classic coming ~ 10/1",
    "man im thirsty asf",
    "why am i thirsty asf?",
    "i need water",
    "im so thirsty",
    "i barely ever touch the 'tips.js' file, so when new drops, its like jesus' second coming",
    ((()=>{try{return generateId(10)}catch{return "RnhPMlBiZlFqVw=="}})()),
    "((()=>{try{return generateId(10)}catch{return 'RnhPMlBiZlFqVw=='}})())",
    "console.log();",
    "document.getElementById();",
    "i listened to the sky under the sea 166 times this week",
    "if yall like coding in js, please help me mantain beansite. i cant keep doing this",
    "apperently yall are reading these, so hi",
    "i cant spell for shit man",
    "the day vercel gets blocked is the day i transfer",
    "bringus",
    "im bored asf rn",
    "goob",
    "https://github.com/Beansite-Dev/beansite-xp/",
    "https://github.com/Beansite-Dev/",
    "It's ironic, some of these tips date back to 95 😭 there's still nods to 'CMD' (replaced with Beanshell in XP i think)",
    "Now deployed with firebase!!",
    "Firebean Prox coming soon",
    "MASSIVE THEME DROP",
    "There's a bunch of new themes in settings, check them out!",
    "These fluctuate between actual tips and random shit so often its scary",
    "lucy bedroque my goat",
    "i been tryna get geeked",
    "i like this osa mason guy",
    "i need to read the game request link lowk",
    "finally picked this up again",
    "che so peak",
    "rest in bass",
    "unmusique",
    "he said he likes girls",
    "nothing to see here",
    "If anyone wants to make themes, it's really simple",
    "Wanna contribute? just hit me an email at m1dnightgmrofficial@gmail.com",
    "Recomendations? m1dnightgmrofficial@gmail.com",
    "PSYKOTIC OUT NOW !!",
    "2 peak albums in one year, thanks lil o",
    "gyro is heavenly (both yes)",
    "yall keep asking 'what website u use' i made the website lmao this is all from scratch",
    "no website builder used to make this, we aint on that dorky shi",
    "website builders buns, thats why beansite's made from scratch",
    "How long til i get sora 2 videos of me",
    "there are so many typos in this file lmao",
    "jsx>>js",
    "100% nodejs",
    "correction, tsx>>ts",
    "i <3 typescript",
    "i really should learn typescript",
    "holy motion spam",
    "i used to be so fucking corny",
    "finally learnt typescript, as a correction to my old shi",
    "90210",
    "commit & sync",
    "'ExpressDerivedWinModifierAtom' (yes that's actually in the source 😭)",
    "tweaky time",
    "finally learned how to write commit messages",
    "kill me",
    "save me",
    "yarn<<pnpm icl",
    "there aren't any actual tips in here anyway"
];
export default tips;